<template>
  <section class="duty-content">
    <el-row :gutter="10">
      <el-col :span="4">
        <div class="duty-preview">
          <div class="duty-title">
            <i class="el-icon-picture-outline-round"></i>
            <span>最新动态</span>
          </div>
          <el-carousel height="150px" indicator-position="none">
            <el-carousel-item v-for="item in dynamicList.slice(0, 5)" :key="item.id">
              <el-image style="width: 100%;height: 100%;" fit="cover" :src="item.poster"></el-image>
            </el-carousel-item>
          </el-carousel>
          <div class="content-block">
            <el-row :gutter="1" v-for="item in dynamicList" :key="item.id" class="content-list-item">
              <el-col :span="1">
                <div class="content-list-item-dot"></div>
              </el-col>
              <el-col :span="23">
                <div class="content-title" @click="handleItemClick(item.id)">{{item.title}}</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="20">
        <router-view/>
      </el-col>
    </el-row>
  </section>
</template>
<script>
  import { dynamicDutyIndex} from '@/api/restapi.js'
  export default {
    data () {
      return {
        dynamicList: []
      }
    },
    mounted () {
      dynamicDutyIndex().then(res => {
        if(res.data.code===0){
          this.dynamicList = res.data.data
        }else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      })
    },
    methods: {
      handleItemClick (id) {
        if (this.$router.currentRoute.path === '/portal/duty/detail') {
          this.$router.replace('/portal/duty/detail?id=' + id)
        }else {
          this.$router.push('/portal/duty/detail?id=' + id)
        }
      }
    }
  }
</script>
<style>
  .duty-preview {

  }
  .duty-preview .duty-title {
    background: #0068BC;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    color: #FFFFFF;
    font-size: 22px;
    font-weight: 800;
  }
  .duty-content .content-block {
    background: #FFFFFF;
    padding: 5px;
  }
  .duty-content .content-list-item {
    margin-top: 10px;
    font-size: 13px;
    cursor: pointer;
    height: 18px;
    line-height: 18px;
  }
  .duty-content .content-list-item .content-title {
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space:nowrap;
    height: 18px;
  }
  .duty-content .content-list-item .content-list-item-dot{
    margin-top: 7px;
    height: 4px;
    width: 4px;
    background: #0068BC;
  }
</style>



// WEBPACK FOOTER //
// src/components/portal/DynamicDuty.vue